import React from 'react';
import { Fit, RawText, fs } from '../parts/fields';
import { Head, Logo } from '../parts/chrome';
import { rows as readRows, useSlide } from '../parts/context';

// #region TableLayout
/** A comparison table: first row is the header, up to eight rows and five columns. */
export const TableLayout: React.FunctionComponent = (): React.ReactElement => {
    const { slide, onFieldChange } = useSlide();
    const grid = readRows(slide.fields.rows);
    const cols = grid.reduce((m, r) => Math.max(m, r.length), 0);
    const [header, ...body] = grid;
    const size = grid.length <= 4 ? 30 : grid.length <= 6 ? 26 : 23;
    const pad = grid.length <= 4 ? '30px 32px' : grid.length <= 6 ? '22px 28px' : '16px 24px';
    const change = (r: number, c: number, v: string): void => {
        const next = grid.map((row) => [...row]);
        while (next[r].length < cols) next[r].push('');
        next[r][c] = v;
        onFieldChange?.('rows', next);
    };
    const cell = (r: number, c: number, head: boolean): React.ReactNode => (
        <RawText raw={grid[r]?.[c] ?? ''} fieldKey={`rows.${r}.${c}`} onChange={(v) => change(r, c, v)} as="span" placeholder={head ? 'Heading' : '—'} max={60} />
    );
    return (
        <>
            <div className="wd-pad">
                <Head />
                <Fit style={{ flex: 1 }}>
                    {header ? (
                        <table className="wd-table" style={{ fontSize: fs(size), lineHeight: 1.3 }}>
                            {cols > 2 ? <colgroup><col style={{ width: `${Math.round(100 / cols + 6)}%` }} /></colgroup> : null}
                            <thead><tr>{Array.from({ length: cols }, (_, c) => <th key={c} style={{ padding: pad }}>{cell(0, c, true)}</th>)}</tr></thead>
                            <tbody>
                                {body.map((_, i) => (
                                    <tr key={i}>{Array.from({ length: cols }, (_, c) => <td key={c} style={{ padding: pad }}>{cell(i + 1, c, false)}</td>)}</tr>
                                ))}
                            </tbody>
                        </table>
                    ) : null}
                </Fit>
            </div>
            <Logo />
        </>
    );
};
